import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import tw from "tailwind-styled-components";
import {
  Wrapper,
  InputGroup,
  CombineInputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import { BoxHead, Underline } from "../Styles/PageStyles";
import moment from "moment";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Enter valid mobile")
    .required("Required"),
  businessEmail: Yup.string().email("Invalid email"),
});

const ProfileBasicInfo = ({
  apiData,
  updateProfileLoading,
  updateProfileMutate,
}) => {
  const initialValues = {
    name: apiData?.name || "",
    mobile: apiData?.mobile || "",
    city: apiData?.city || "",
    regId: apiData?.regId || "",
    status: apiData?.status || "",
    device: apiData?.device || "",
    businessName: apiData?.businessName || "",
    businessAddress: apiData?.businessAddress || "",
    businessEmail: apiData?.businessEmail || "",
    website: apiData?.website || "",
    gstNo: apiData?.gstNo || "",
  };

  const getInputClass = (disabled = false) =>
    disabled
      ? "pl-2 rounded-md w-full border border-gray-300 h-12 bg-gray-100 cursor-not-allowed"
      : "pl-2 rounded-md w-full border border-gray-400 h-12";

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => updateProfileMutate(values)}
    >
      {({ errors, touched }) => (
        <Form>
          <Wrapper>

            {/* <BoxHead> */}
            <TabTitle>
                Profile Overview
                <Underline />
            </TabTitle>
    
            {/* <div className="text-xs text-gray-500">
                Created on{" "}
                <span className="font-medium text-gray-700">
                {moment(apiData?.createdAt).format("DD, MMM YYYY")}
                </span>
            </div> */}
            {/* </BoxHead> */}
            {/* Row 1 */}
            <CombineInputGroup>
              <InputGroup>
                <Label>Name *</Label>

                <FieldWrapper>
                  <Field
                    name="name"
                    className={getInputClass()}
                  />
                </FieldWrapper>

                {touched.name && errors.name && (
                  <Error>{errors.name}</Error>
                )}
              </InputGroup>

              <InputGroup>
                <Label>Mobile *</Label>

                <FieldWrapper>
                  <Field
                    name="mobile"
                    className={getInputClass()}
                  />
                </FieldWrapper>

                {touched.mobile && errors.mobile && (
                  <Error>{errors.mobile}</Error>
                )}
              </InputGroup>
            </CombineInputGroup>

            {/* Row 2 */}
            <CombineInputGroup>

              <InputGroup>
                <Label>GST Number</Label>

                <FieldWrapper>
                  <Field
                    name="gstNo"
                    className={getInputClass()}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label>Business Name</Label>

                <FieldWrapper>
                  <Field
                    name="businessName"
                    className={getInputClass()}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label>Business Email</Label>

                <FieldWrapper>
                  <Field
                    name="businessEmail"
                    className={getInputClass()}
                  />
                </FieldWrapper>
              </InputGroup>

              {/* <InputGroup>
                <Label>Website</Label>

                <FieldWrapper>
                  <Field
                    name="website"
                    className={getInputClass()}
                  />
                </FieldWrapper>
              </InputGroup> */}
            </CombineInputGroup>

            {/* Row 3 */}
            <AddressGrid>
              <AddressInput>
                <InputGroup>
                  <Label>Business Address</Label>

                  <FieldWrapper>
                    <Field
                      name="businessAddress"
                      className={getInputClass()}
                    />
                  </FieldWrapper>
                </InputGroup>
              </AddressInput>
                <InputGroup>
                  <Label>City</Label>

                  <FieldWrapper>
                  <Field
                      name="city"
                      className={getInputClass()}
                      placeholder="Enter city"
                  />
                  </FieldWrapper>
              </InputGroup>
            </AddressGrid>
          </Wrapper>

          <BtnWrapper>
            <SubmitBtn
              type="submit"
              disabled={updateProfileLoading}
              className="text-sm w-24 md:w-20 h-7 md:text-xs"
            >
              {updateProfileLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default ProfileBasicInfo;

const BtnWrapper = tw.div`
w-full
flex
justify-end
mt-6
`;
const FieldWrapper = tw.div`w-full`;

const Error = tw.p`
text-red-500
text-sm
mt-1
`;
const TabTitle = tw.h2`text-lg text-black font-semibold`;
const AddressGrid = tw.div`grid md:grid-cols-3 grid-cols-1 gap-4`;
const AddressInput = tw.div`grid md:col-span-2 col-span-1`;
